import React, { useEffect, useMemo, useState } from 'react'
import FlightDealTile from 'components/Flights/FlightMerchandising/FlightDealTile'
import Heading from 'components/Luxkit/Typography/Heading'
import useFlightDealLocations from 'home/hooks/useFlightDealLocations'
import LayoutContainer from 'components/Common/LayoutContainer'
import { MAX_CAROUSEL_ITEM_COUNT } from '../OfferCarousels/common/constants'
import { take } from 'lib/array/arrayUtils'
import FullWidthCarouselWithAnalytics from 'components/WithAnalytics/Carousel/FullWidthCarouselWithAnalytics'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import FlightLocationSelect from './FlightLocationSelect'
import { rem } from 'polished'
import useFlightDeals from 'hooks/Flights/useFlightDeals'
import Group from 'components/utils/Group'
import FlightDealTileSkeletonLoader from './FlightDealSkeletonLoader'

interface Props {
  title: string;
}

function FlightDeals(props: Props) {
  const { title } = props
  const [flightDeals, fetching] = useFlightDeals()
  const [locations, defaultLocation] = useFlightDealLocations()
  const [selectedLocation, setLocation] = useState<{ code: string, name: string} | undefined>(defaultLocation)

  const filteredFlightDeals = useMemo(() => {
    if (selectedLocation) {
      return flightDeals.filter(({ originAirportCode }) => originAirportCode === selectedLocation.code)
    }
    return []
  }, [flightDeals, selectedLocation])

  useEffect(() => {
    // Locations may have not be available on load, so no location will be set
    // sync the 'default' if none selected
    if (!selectedLocation && defaultLocation) {
      setLocation(defaultLocation)
    }
  }, [defaultLocation, selectedLocation])

  return (
    <VerticalSpacer gap={20}>
      <LayoutContainer>
        <Group direction="vertical" tabletDirection="horizontal" tabletGap={8}>
          <Heading variant="heading2">{title}</Heading>
          {selectedLocation && locations.length > 1 &&
            <FlightLocationSelect
              selected={selectedLocation}
              locations={locations}
              onChangeLocation={setLocation}
            />
          }
        </Group>
      </LayoutContainer>
      <FullWidthCarouselWithAnalytics
        width={`calc(100vw - ${rem(56)})`}
        snap="start"
        tabletWidth={rem(366)}
        itemsPerArrow={3}
      >
        {fetching && <>
          <FlightDealTileSkeletonLoader />
          <FlightDealTileSkeletonLoader />
          <FlightDealTileSkeletonLoader />
          <FlightDealTileSkeletonLoader />
        </>}
        {!fetching && take(filteredFlightDeals, MAX_CAROUSEL_ITEM_COUNT).map((flightDeal) => (
          <FlightDealTile key={flightDeal.id} flightDeal={flightDeal}/>
        ))}
      </FullWidthCarouselWithAnalytics>
    </VerticalSpacer>
  )
}

export default FlightDeals
